// extracted by mini-css-extract-plugin
module.exports = {"btn":"w_p x_rZ x_rB h_fp h_fD h_fs h_hf","full":"w_q5 h_dp h_dz"};